import { Controller } from "stimulus";
import Swiper from "swiper";

export default class extends Controller {
  connect() {
    this.groupSiper = new Swiper('.SliderHalfBar__carousel', {
      loop: true,
      navigation: {
        prevEl: '.SliderHalfBar__carousel-previous-button',
        nextEl: '.SliderHalfBar__carousel-next-button',
      },
    });

    this.groupSiper.on('transitionEnd', () => {
      this.setCarouselGroupName();
    })

    this.setCarouselGroupName();
  }

  setCarouselGroupName() {
    document
      .querySelector('.js-SliderHalfBar__carousel-group-name')
      .innerText = document.querySelector('.swiper-slide-active').getAttribute('alt')
  }

  toggleHighlight(event) {
    let clickedElement = event.currentTarget;

    if (!clickedElement.classList.contains('SliderHalfBar__carousel-action-highlighted')) {
      let actionElement = document.querySelector('.SliderHalfBar__carousel-action-highlighted')
      actionElement.classList.remove('SliderHalfBar__carousel-action-highlighted')
      clickedElement.classList.add('SliderHalfBar__carousel-action-highlighted')
    }
  }
}
